import { ApolloLink } from '@apollo/client';
import tokenStorage from 'src/modules/authentication/storage/token/storage';
const authLink = new ApolloLink((operation, forward) => {
    const token = tokenStorage.getToken();
    operation.setContext(({ headers = {} }) => ({
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : '',
        },
    }));
    return forward(operation).map(data => {
        const context = operation.getContext();
        if (context.response?.headers) {
            const newToken = context.response.headers.get('new-token');
            if (newToken) {
                tokenStorage.setToken(newToken);
            }
        }
        return data;
    });
});
export default authLink;
